import axios from 'axios';
import { toast } from 'react-toastify';
const API_URL = process.env.REACT_APP_BACKEND_URL + '/api/warehouses';

export const getWarehouses = async () => {
    try {
        const response = await axios.get(API_URL);
        return response.data;
    } catch (error) {
        // Don't show toast for authentication errors (expected during user switching)
        if (error.response?.status !== 401) {
            const message = (
                error.response && error.response.data && error.response.data.message) ||
                error.message || error.toString();
            toast.error(message);
        }
        return []; // Return empty array on error
    }
};

export const createWarehouse = async (warehouseData) => {
    const response = await axios.post(API_URL, warehouseData);
    return response.data;
};

export const deleteWarehouse = async (warehouseId) => {
    const response = await axios.delete(`${API_URL}/${warehouseId}`);
    return response.data;
};

export const updateWarehouse = async (warehouseId, warehouseData) => {
    const response = await axios.put(`${API_URL}/${warehouseId}`, warehouseData);
    return response.data;
};